import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { Autocomplete, TextField } from "@mui/material";

import { api } from "../../../../services/Api";

export default function PesquisaUsuario({
  label,
  value,
  onChange,
  required = false,
  error,
  helperText,
  ...rest
}) {
  const [usuarios, setUsuarios] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    async function recebeUsuarios() {
      try {
        const { data } = await api.get(`/v2/controleAcesso/todosUsuarios`);

        setUsuarios(data.usuarios);
      } catch (error) {
        enqueueSnackbar("Erro! Não foi possível buscar os usuários.", {
          variant: "error",
        });
      }
    }
    recebeUsuarios();
  }, [enqueueSnackbar]);

  const labelAsterisco = required && label ? (
    <>
      {label} <span style={{ color: '#666666' }}>*</span>
    </>
  ) : label || "Usuário Responsável";

  return (
    <>
      <Autocomplete
        {...rest}
        value={value}
        onChange={(event, value) => onChange(value)}
        disablePortal
        id="combo-box-demo"
        options={usuarios}
        getOptionLabel={option => option.username}
        fullWidth
        renderInput={params => (
          <TextField
            required={false}
            variant="standard"
            {...params}
            label={labelAsterisco}
            InputLabelProps={{
              ...params.InputLabelProps,
              required: false,
            }}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </>
  );
}
